import { render, staticRenderFns } from "./SidebarAddAddress.vue?vue&type=template&id=c0cb0472&"
import script from "./SidebarAddAddress.vue?vue&type=script&lang=js&"
export * from "./SidebarAddAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports